console.log(' process.env', process.env);
const processEnv: {
  [key: string]: {
    baseURL?: string;
    remoteServiceBaseUrl: string;
  };
} = {
  local: {
    // remoteServiceBaseUrl: 'http://192.168.9.24:8801/mrp_dev_feature',
    remoteServiceBaseUrl: 'http://192.168.9.24:8801/marketing_wyf',
  },
  test: {
    baseURL: 'https://OP-Salarytest.wondfo.com.cn',
    remoteServiceBaseUrl: 'https://OP-Salarytest.wondfo.com.cn/appapi',
  },
  prod: {
    baseURL: 'https://OP-Salary.wondfo.com.cn',
    remoteServiceBaseUrl: 'https://OP-Salary.wondfo.com.cn/appapi',
  },
};
const REACT_APP_ENV = process.env.REACT_APP_ENV || 'local';
const AppConsts = {
  ...processEnv[REACT_APP_ENV],
};
export default AppConsts;
